/*
Heavily modified to allow for per variant swapping rather than per product swapping. 
*
Sections and description are swapped based on data from variant metafields.
*
Images are swapped based on alt text and variant color options.
*/

if (!customElements.get('coco-shuffle')) {
  
  window.debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
        }, wait);
    };
  }
  class CocoShuffle extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.selectedSize = null;
      this.selectedLength = null;
      this.colors = null;
    }
    
    connectedCallback() {
      this.products = JSON.parse(this.dataset.productsJson.replace("}]},]", "}]}]")
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
        );
      this.selectedProduct = this.products[0];

      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get('variant');

      if (variantParam) {
        this.currentVariant = this.selectedProduct.variants.find((el) => Number(el.id) === Number(variantParam));
      } else {
        this.currentVariant = this.selectedProduct.variants.find(({ default_selected }) => default_selected);
      }

      const pdpVariantsGallery = document.querySelector('.pdp_gallery--variants');

      if (pdpVariantsGallery) pdpVariantsGallery.classList.add('is-loaded')
                         
      this.colors = this.selectedProduct.options_with_values.find((item) => item.name.toLowerCase().includes('color'))?.values ?? [];
      this.addDelegatedClickListeners();
      this.createCustomEvents();
      
      // any elements that might not exist yet when the ACE gets added to the DOM
      this.imagesWrapper = [...this.querySelectorAll('[data-product-images]')];
      this.displayPrice = [...this.querySelectorAll('[data-display-price]')];
      this.displayOptions = this.querySelector('[data-display-options]');
      this.displayTitle = [...this.querySelectorAll('[data-display-title]')];
      this.displaySku = [...this.querySelectorAll('[data-display-sku]')];
      this.mainSelect = this.querySelector('[data-main-select]');
      this.showSizeChart = this.dataset.showSizeChart === 'true';
      this.querySelector('[data-form-fieldset]')?.removeAttribute('disabled', true);
      this.showSelectedColor = this.classList.contains('show-selected-color');
      this.swapOutATC();
      this.populateSelectedProductImages();
      this.populateSelectedProductOptions();
      this.addEventListener('activeIndexChange', (e) => {
        this.querySelectorAll('[data-action="select-thumb"]')
          .forEach((el, i) => {
            if ((i) === Number(e.detail)) {
              el.classList.add('selected');
              if (window.matchMedia('(min-width: 768px)').matches) {
                el.closest('[data-product-images="thumbnail"]').scrollTop = (el.offsetTop - (el.offsetHeight + 4));
              } else {
                el.closest('[data-product-images="thumbnail"]').scrollLeft = (el.offsetLeft - 16);
              }
            } else el.classList.remove('selected');
          });
      });
    }
      
    addDelegatedClickListeners() {
      ['click', 'change'].forEach((eventType) =>  this.addEventListener(eventType, debounce((e) => {
          const clickedElement = e.target.closest('[data-action]');
          if (!clickedElement) return;
          
          const {
            action,
            option,
            optionType,
            index
          } = clickedElement.dataset;
          
          if (this.colors.find((item) => item === option)) { // is a color swap, swap images
            this.populateSelectedProductImages();
          }
          
          switch (action) {
            case 'select-thumb':
              this.querySelectorAll('[data-action="select-thumb"].selected')
                .forEach((el) => {
                  el.classList.remove('selected');
                });
              clickedElement.classList.add('selected');
              
              this.querySelector('swiper-carousel')?.slider?.slideTo(index);
            break;
            case 'option-choice':
              if (!option) {
                console.error('Input with [data-action="option-choice"] is missing a [data-option="value"] attr');
                return;
              }
              
              // Update active color value text (only for color options)
              if (optionType && optionType.toLowerCase().includes('color')) {
                const swatchWrapper = clickedElement.closest('.swatch');
                if (swatchWrapper) {
                  const activeColorValue = swatchWrapper.querySelector('.active-color-value');
                  if (activeColorValue) {
                    activeColorValue.textContent = `: ${option}`;
                  }
                }
              }
              
              const optionIndex = this.selectedProduct.options_with_values.findIndex((option) => {
                return option.name === optionType;
              });
              let thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
              thisOptionSet[optionIndex] = option;
              
              this.currentVariant = this.selectedProduct.variants
                .find((variant) => {
                  if (thisOptionSet.toString() === variant.options.toString()) return variant;
                });
              
              this.populateSelectedProductPrice();
              this.populateSelectedProductOptions();
              this.swapOutATC();
              
              [...document.querySelectorAll('[data-show]')].forEach((el) => {
                if (Number(el.dataset.show) === Number(this.currentVariant?.id)) {
                  el.style.display = null;
                  if (el.querySelector('swiper-carousel')) {
                    setTimeout(() => {
                      el.querySelector('swiper-carousel').reinit();
                    }, 10);
                  }
                } else el.style.display = 'none';
              });
              
              window.dispatchEvent(this.variantUpdatedEvent);

              if (!this?.currentVariant) return;
              let notify = this.querySelector('.notify_form');
              this.currentVariant.available ? notify.style.display = "none" : notify.style.display = "block"
              this.displaySku.forEach(sku => sku.innerHTML = this.currentVariant.sku.split('|')[0]);
              this.mainSelect.value = this.currentVariant.id;
              
              const isInPopup = this.closest('.quick-add-popup__body') || this.closest('[data-modal-target]');
              
              if (!isInPopup) {
                history.replaceState(this.selectedProduct.title, '', this.currentVariant.url);
                
                if (this.currentVariant) {
                  history.replaceState(this.currentVariant.title, '', this.currentVariant.url);
                  return;
                }
              }  
            break;
            default: break;
          }
        }), 200)
      );
    }
    
    createCustomEvents() {
      this.addToCartEvent = new CustomEvent('coco-shuffle:add-to-cart', {});
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      this.variantUpdatedEvent = new CustomEvent('coco-shuffle:variant-updated', {});
    }
    
    populateSelectedProductImages() {
      if (!this.currentVariant || this.selectedProduct.variants.length < 2 || this.selectedProduct.media.length < 2) return;
      const variantColor = this.currentVariant.options.find((item) => this.colors.some((color) => color === item));
      const productOptionValues = this.selectedProduct.options_with_values.map(item => item.values.map(value => value)).flat();
      const currentSliderIndex = this.querySelector('swiper-carousel')?.slider?.activeIndex || this.querySelector('swiper-carousel .swiper-slide-active')?.getAttribute('data-index');

      this.imagesWrapper.forEach(wrapper => {
        // set this min height to prevent big reflow
        wrapper.style.minHeight = `${wrapper.offsetHeight}px`;

        wrapper.innerHTML = '';
        if (wrapper.dataset.productImages === "thumbnail") {
          let renderedOrder = 0;
          this.selectedProduct.media.forEach((media) => {
            const { alt, poster, src } = media;
            if (!alt.toLowerCase().includes(`color-${variantColor.toLowerCase().replace(' ', '-')}`) && productOptionValues.some(value => alt.toLowerCase().includes(value.toLowerCase().replace(' ', '-')))) return;
            if (alt.indexOf("feat_") == -1 && alt.indexOf("feat-") == -1 ){
              wrapper.innerHTML += `
                <button 
                  type="button"
                  data-action="select-thumb"
                  data-index="${renderedOrder}"
                  class="${renderedOrder === currentSliderIndex ? 'selected' : ''}"          
                >
                  <img 
                    height="1200" 
                    width="1200" 
                    sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" 
                    alt="${alt ? alt : this.selectedProduct.title}" 
                    src="${poster ? poster : src}"
                  >
                </button>
              `; 
              renderedOrder ++;
            }
          });
          
          return;
        }
        
        this.selectedProduct.media.forEach((media, i) => {
          if (media.media_type === 'video') {
            const { alt, poster, sources } = media;
            if (!alt.toLowerCase().includes(variantColor.toLowerCase().replace(' ', '-')) && productOptionValues.some(value => alt.toLowerCase().includes(value.toLowerCase().replace(' ', '-')))) return;

            const source = sources.find(x => x.format === 'mp4');
            if (!source) return;
            
            const template = this.querySelector('[data-template="product-video"]')?.innerHTML.toString();
            const templateString = template.replaceAll('{poster}', poster).replaceAll('{alt}', alt).replaceAll('{source}', source.url).replaceAll('{mime_type}', source.mime_type);
            const templateElement = document.createElement('div');
            templateElement.innerHTML = templateString;
            const templateNode = templateElement.firstElementChild;
            wrapper.appendChild(templateNode);

            return;
          }
          
          // is there a template defined?
          const template = this.querySelector('[data-template="product-image"]')?.innerHTML.toString();
          const { alt, src, variants } = media;
          if (!alt.toLowerCase().includes(variantColor.toLowerCase().replace(' ', '-')) && productOptionValues.some(value => alt.toLowerCase().includes(value.toLowerCase().replace(' ', '-')))) return;

          if (!template) { 
            if (alt.indexOf("_feat") == -1 && alt.indexOf("-feat") == -1 ){
              wrapper.innerHTML += `
                <img height="1200" width="1200" sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" alt="${alt ? alt : this.selectedProduct.title}" src="${src}">
              `;
            }
            return;
          }
          
          const loadedImage = new Image();
          loadedImage.src = src;
          
          const templateString = template.replaceAll('{src}', src).replaceAll('{alt}', alt).replaceAll('{variants}', variants).replaceAll('{classes}', '').replaceAll('{index}', i);
          const templateElement = document.createElement('div');
          templateElement.innerHTML = templateString;
          const templateNode = templateElement.firstElementChild;
          
          templateNode.querySelector('img').style.opacity = 0;
          templateNode.querySelector('img').style.transition = '0.2s';
          wrapper.appendChild(templateNode);

          if (loadedImage.complete) {
            templateNode.querySelector('img').style.opacity = 1;
            if ((i + 1) === this.selectedProduct.media.length) {
              window.dispatchEvent(this.productUpdatedEvent);
              wrapper.style.minHeight = null;
            }
          } else {
            loadedImage.onload = () => {
              templateNode.querySelector('img').style.opacity = 1;
              if ((i + 1) === this.selectedProduct.media.length) {
                window.dispatchEvent(this.productUpdatedEvent);
                wrapper.style.minHeight = null;
              }
            }
          }            
        });       
      });
    }
    
    populateSelectedProductPrice() {
      if (!this.currentVariant || !this.displayPrice) return;
      this.displayPrice.forEach(el => {        
        el.innerHTML = this.currentVariant?.compare_at_price > this?.currentVariant?.price
          ? 
          ` 
            <span itemprop="price" content="${(this.currentVariant?.price / 100)}" class="sale"><span data-price class="current-price current_price ${this.selectedProduct.available ? `` : `hidden`}"><span class="money">$${(this.currentVariant?.price / 100)}</span></span></span>
            <span class="was_price" data-compare-price><span class="money">$${(this.currentVariant?.compare_at_price / 100)}</span></span>
          `
          : 
          `<span itemprop="price" content="${(this.currentVariant?.price / 100)}"><span data-price class="current-price current_price ${this.selectedProduct.available ? `` : `hidden`}"><span class="money">$${(this.currentVariant?.price / 100)}</span></span></span>`;
      });
    } 
    
    populateSelectedProductOptions() {
      if (!this.displayOptions || !this.selectedProduct || !this.currentVariant) return;
      const selectedOptions = [...this.querySelectorAll('[data-action="option-choice"]:checked')].map(({ value }) => value);
      const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }) => {
        if (values.length < 1) return;
        return `
          <div class="swatch variant">
            <div class="title-wrap option_title variant__title">
              <strong>${name}${name.toLowerCase().includes('color') && this.showSelectedColor ? `<span class="active-color-value"></span>` : ``}</strong>
              ${(name.toLowerCase().includes('size' || 'length' || 'band') && this.showSizeChart) ? 
                `<a href="#size-chart${this.selectedProduct.id}-info" class="size_chart" data-remodal-target="size-chart${this.selectedProduct.id}" data-no-instant>
                  Size Guide &nearr;
                </a>` : ``}
            </div>
            <div class="selector-list variant__options variant__options--${name.toLowerCase()} ${name.toLowerCase().includes('band') ? 'variant__options--band' : ''} ${name == "Length" ? `variant__options--length` : ``} ${name == "MM" ? `variant__options--mm` : ``}">
              ${values.map((value) => {
                const indexOfOption = this.selectedProduct.options_with_values
                  .findIndex(({ values }) => {
                    return values.find((x) => x === value);
                  });
                let thisOptionSet = [...selectedOptions];
                thisOptionSet[indexOfOption] = value;
                
                const matchingProduct = this.selectedProduct.variants.find(({ options }) => {
                  return thisOptionSet.toString() === options.toString();
                });  
                                        
                if (name.includes('color') || name.includes('Color')) {
                  return `
                    <div class="swatch-wrapper">
                      <input
                        data-matching-product="${matchingProduct?.options}"
                        data-action="option-choice"
                        data-option="${value}"
                        data-option-type="${name}"
                        id="${this.selectedProduct.id}-${value}" 
                        type="radio" 
                        name="${name}" 
                        value="${value}" 
                        ${(this.currentVariant.options[indexOfOption] === value) ? 'checked' : ''}
                      > 
                      <div data-value="${value}" class="swatch-element color ${value.toLowerCase()}-swatch ${matchingProduct?.available ? 'available' : 'soldout'}"> 
                      <div class="tooltip">${value}</div> 
                        <label for="${this.selectedProduct.id}-${value}" style="background-image: url(https://speidel.com/cdn/shop/t/205/assets/${value.toLowerCase().replace(' ', '-').trim()}_50x.png); background-color: ${value.split(' ').pop()}; "> 
                          <span class="crossed-out"></span>
                        </label>
                      </div>
                    </div>
                  `
                }
                
                return `
                  <input 
                    data-action="option-choice"
                    data-option="${value}"
                    data-option-type="${name}"
                    id="${this.selectedProduct.id}-${value}" 
                    type="radio"
                    value="${value}"
                    name="${name}"
                    ${(this.currentVariant.options[indexOfOption] === value) ? 'checked' : ''}
                  >
                  <div class="swatch-element band ${matchingProduct?.available ? '' : 'soldout'}">
                    <div class=" selector-wrap">
                      <span class="selector">
                        <label for="${this.selectedProduct.id}-${value}" class="selector-label">
                          ${value}
                          <span class="crossed-out"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  `
              }).join('')}
            </div>
          </div>
        </div>`
      }).join('')
      this.displayOptions.innerHTML = optionsHTMLString;
      
      // Set initial active color values for checked options (only for color options)
      const checkedOptions = this.querySelectorAll('[data-action="option-choice"]:checked');
      checkedOptions.forEach(input => {
        const optionType = input.getAttribute('data-option-type');
        if (optionType && optionType.toLowerCase().includes('color')) {
          const swatchWrapper = input.closest('.swatch');
          if (swatchWrapper) {
            const activeColorValue = swatchWrapper.querySelector('.active-color-value');
            if (activeColorValue) {
              activeColorValue.textContent = `: ${input.value}`;
            }
          }
        }
      });
    }
      
    swapOutATC() {
      const atcButton = this.querySelectorAll('[data-atc]');
      if (!this.currentVariant) {
        atcButton.forEach(button => { 
          button.setAttribute('disabled', true);
          button.querySelector('span').innerHTML = "Unavailable";
        });
        return;
      } 
      if (this.currentVariant.available){
        atcButton.forEach(button => { 
          button.removeAttribute('disabled');
          button.querySelector('span').innerHTML = `Add to cart`; 
        });
      } else {
        atcButton.forEach(button => { 
          button.setAttribute('disabled', true);
          button.querySelector('span').innerHTML = `Unavailable`;
        });
      }
    }
  }
    
  customElements.define('coco-shuffle', CocoShuffle);
}